<template>
  <TablePaginated
      label="Tail numbers users"
      :main-list="itemData"
      :is-global-percent="isGlobalPercent"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import TablePaginated from '../../../TablePaginated.vue';

export default {
  name: 'PagedListTailNumberUsers',
  components: {
    TablePaginated,
  },

  props: {
    itemData: {
      type: [Array],
      default() {
        return ([]);
      },
    },
  },

  computed: {
    ...mapGetters({
      isGlobalPercent: 'metrics/isGlobalPercent',
    }),
  },
};
</script>
